import { createContext, useContext } from 'react';

export interface ReceiptContact {
  email: string;
  firstName: string;
  lastName: string;
}
interface ReceiptContactState {
  contact: ReceiptContact;
  updateContact: (patch: Partial<ReceiptContact>) => void;
}
export const ReceiptContactContext = createContext<ReceiptContactState | null>(null);

export function useReceiptContact(): ReceiptContactState {
  const context = useContext(ReceiptContactContext);
  if (!context) throw new Error('ReceiptContactProvider required');
  return context;
}
